<template>
  <div class="container">
    <div class="main">
      <div class="module_section1">
        <!-- <h3 class="title">关于我们</h3>
        <p class="cont">哆点数字能源实行“产品+定制”双引擎产品战略，即80%的产品化+20%的定制化，从而精准匹配新能源企业数智化转型需求，给企业提供100%的匹配。</p>
        <a href="javascript:;" class="btn" @click="goToLink('/index?id=applyUse')">
          方案咨询
          <i class="el-icon-right rightIcon1"></i>
        </a> -->
        <div class="banner_cont">
          <div class="title">关于我们</div>
          <div class="subtitle1">实行“产品+定制”双引擎产品战略，即80%的产品化+20%的定制化，从而精准匹配新能源企业数智化转型需求，给企业提供100%的匹配</div>
          <a href="javascript:;" class="btn" @click="goToLink('/index?id=applyUse')">
            方案咨询
            <i class="el-icon-right rightIcon1"></i>
          </a>
        </div>
      </div>
      
      <div class="module module_section2">
        <h3 class="title">技术组合开创能源数智化</h3>
        <img class="img1" src="https://oss.duodians.com/lambda/office_web/about/about_img1.png" alt="">
        <img class="img2" src="https://oss.duodians.com/lambda/office_web/about/about_img2.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToLink(url) {
      this.$router.push({ path: url })
    }
  }
};
</script>
<style lang='less' scoped>
.container{
  position: relative;
  top:-80px;
  z-index: 1;
  padding-bottom: 100px;
  .main{
    .module{
      width:1200px;
      margin: 0 auto;
    }
    .module_section1{
      color: #fff;
      text-align: center;
      height: 630px;
      background: url('https://oss.duodians.com/lambda/office_web/about/about_bg.jpg') no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      .banner_cont{
      .title{
        font-size: 48px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 48px;
      }
      .subtitle1{
        margin: 50px auto 0;
        width: 900px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 30px;
      }
      .btn{
        margin: 50px auto 0;
        width: 190px;
        height: 50px;
        border: 2px solid;
        border-radius: 28px;
        border-image: linear-gradient(270deg, #4add69 18%, #4cddbd 58%, #3cecf0 43%, #12ee90 99%) 2 2;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #4cddbd;
      }
    }
      .title{
        padding: 170px 0 40px;
        font-size: 48px
      }
      .cont{
        width: 946px;
        margin: 0 auto 42px;
        font-size: 16px;
        line-height: 30px;
        text-align: justify;
      }
      .btn{
        width: 148px;
        height: 50px;
        border: 2px solid;
        border-image: linear-gradient(270deg, #4add69 18%, #4cddbd 58%, #3cecf0 43%, #12ee90 99%) 2 2;
        border-radius: 28px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #4cddbd;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        .rightIcon1{
          margin-left: 10px;
        }
      } 
    }
    .module_section2{
      text-align: center;
      .title{
        height: 54px;
        font-size: 46px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        color: #000000;
        line-height: 54px;
        margin: 99px 0 48px
      }
      .img1{
        width: 74px;
        margin-bottom: 70px;
      }
      .img2{
        width: 1160px
      }
    }
  } 
}

</style>


// WEBPACK FOOTER //
// src/components/about/about.vue